import type { LandingContent } from "../content/types";
import { Container } from "../components/Container";
import { FeatureCard } from "../components/FeatureCard";

type FeatureGridProps = {
  content: LandingContent["features"];
};

export function FeatureGrid({ content }: FeatureGridProps) {
  return (
    <section className="bg-bg-secondary py-20 lg:py-24">
      <Container>
        <div className="flex flex-col gap-3.5">
          <span className="inline-flex w-fit items-center rounded-full border border-subtle bg-accent-blue-soft px-3.5 py-2 text-[13px] font-semibold text-accent-blue">
            {content.eyebrow}
          </span>
          <h2 className="font-display text-3xl font-bold text-text-primary sm:text-4xl">{content.title}</h2>
        </div>
        <div className="mt-11 grid gap-6 md:grid-cols-2">
          {content.cards.map((card) => (
            <FeatureCard key={card.title} card={card} />
          ))}
        </div>
      </Container>
    </section>
  );
}
